/**
 * Mock network backups — exercises both the "fresh backup" and "already
 * restored" rows in the debranding history table.
 */
import type { NetworkBackup } from "@/api/schemas/meraki";

export const MOCK_NETWORK_BACKUPS: NetworkBackup[] = [
  {
    id: "bkp-2026-04-29-c4f1",
    createdAt: "2026-04-29T18:42:11Z",
    createdBy: "eduverna",
    networkId: "L_111111111111111111",
    networkName: "marriott-nyc-21-prod",
    restoredAt: null,
    restoredBy: null,
    restoredIntoNetworkId: null,
    summary: { ssidCount: 8, portCount: 96, vlanCount: 9, deviceCount: 14 },
  },
  {
    id: "bkp-2026-04-22-9a2e",
    createdAt: "2026-04-22T09:18:54Z",
    createdBy: "esantizo",
    networkId: "L_111111111111111111",
    networkName: "marriott-nyc-21-prod",
    restoredAt: "2026-04-23T15:02:00Z",
    restoredBy: "esantizo",
    restoredIntoNetworkId: "L_NEW999999999999999",
    summary: { ssidCount: 8, portCount: 96, vlanCount: 9, deviceCount: 14 },
  },
  {
    id: "bkp-2026-03-30-7d77",
    createdAt: "2026-03-30T11:50:00Z",
    createdBy: "kkharitonov",
    networkId: "L_111111111111111111",
    networkName: "marriott-nyc-21-prod",
    restoredAt: null,
    restoredBy: null,
    restoredIntoNetworkId: null,
    summary: { ssidCount: 6, portCount: 96, vlanCount: 7, deviceCount: 14 },
  },
];
